import * as fs from "fs";
import { ViteSSG } from "vite-ssg";

// styles

import "./assets/styles/tailwind.css";

import VueNextSelect from "vue-next-select";
import "./assets/styles/vue-next-select.css";
import VueGTag from "vue-gtag";
import axios from "axios";
import VueCookies from "vue-cookies";
import * as Sentry from "@sentry/vue";

// mouting point for the whole app

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime.js";
import utc from "dayjs/plugin/utc.js";
import { store, utils } from "common-frontend";
import App from "./App.vue";

// router

import routes from "./router";

const { apiPlugin, keysToCamel } = utils;

dayjs.extend(relativeTime);
dayjs.extend(utc);

// vite-ssg: `export const createApp` is required instead of the original `createApp(App).mount('#app')`
export const createApp = ViteSSG(
  App,
  // vue-router options
  {
    routes,
    scrollBehavior() {
      // always scroll to top
      return { top: 0 };
    },
  },
  // function to have custom setups
  ({ app, router }) => {
    // Force a browser reload of whole page if dynamic module names have changed
    router.onError((error, to) => {
      const reloadCount =
        parseInt(app.$cookies.get("module_reload_count"), 10) || 0;
      if (
        error.message.includes("Failed to fetch dynamically imported module")
      ) {
        if (reloadCount < 4) {
          app.$cookies.set("module_reload_count", reloadCount + 1, "5s");
          setTimeout(() => {
            window.location = to.fullPath;
          }, 3000);
        } else {
          throw error;
        }
      }
    });

    app.use(router);
    app.use(store);
    app.use(apiPlugin);

    // app.config.globalProperties.$useHead = useHead;
    if (!import.meta.env.SSR) {
      if (import.meta.env.VITE_SENTRY_DSN !== "null") {
        const integrations = [
          Sentry.browserTracingIntegration({ router }),
          Sentry.replayIntegration({
            networkDetailAllowUrls: [window.location.origin],
          }),
        ];
        Sentry.init({
          app,
          dsn: import.meta.env.VITE_SENTRY_DSN,
          integrations,
          tracePropagationTargets: [import.meta.env.VITE_BASE_URL, /^\//],
          tracesSampleRate: 0.1,
          logErrors: true,
          trackComponents: true,
          replaysSessionSampleRate: 1.0,
          replaysOnErrorSampleRate: 1.0,
        });
      }
    }
    app.component("VueSelect", VueNextSelect);
    if (!import.meta.env.SSR && !window.doNoTrack) {
      app.use(
        VueGTag,
        {
          config: { id: import.meta.env.VITE_GOOGLE_ID },
          includes: [{ id: import.meta.env.VITE_GOOGLE_ADS_ID }],
        },
        router,
      );
    }

    app.config.globalProperties.$dayjs = dayjs;
    app.use(VueCookies, { expires: "7d" });
    store.$app = app;
  },
);
